import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns Bootstrap CSS classes for status badges.
 *
 * Usage:
 *   [ngClass]="record.status | statusBadge"           → record status classes
 *   [ngClass]="report.status | statusBadge:'report'"  → report status classes
 *   [ngClass]="test.status | statusBadge:'test'"      → test status classes
 */
@Pipe({
  name: 'statusBadge',
  standalone: true
})
export class StatusBadgePipe implements PipeTransform {
  transform(
    status: string | null | undefined,
    type: 'record' | 'report' | 'test' = 'record'
  ): string {
    if (!status) return 'bg-secondary';

    const normalizedStatus = status.toLowerCase();

    switch (type) {
      case 'record':
        return this.getRecordStatusClass(normalizedStatus);
      case 'report':
        return this.getReportStatusClass(normalizedStatus);
      case 'test':
        return this.getTestStatusClass(normalizedStatus);
      default:
        return 'bg-secondary';
    }
  }

  private getRecordStatusClass(status: string): string {
    switch (status) {
      case 'draft':
        return 'badge-draft';
      case 'completed':
        return 'badge-completed';
      case 'pending':
        return 'badge-pending';
      case 'cancelled':
        return 'badge-cancelled';
      default:
        return 'bg-secondary';
    }
  }

  private getReportStatusClass(status: string): string {
    switch (status) {
      case 'draft':
        return 'badge-draft';
      case 'generating':
        return 'badge-generating';
      case 'ready':
        return 'badge-ready';
      case 'submitted':
        return 'badge-submitted';
      case 'failed':
        return 'badge-failed';
      default:
        return 'bg-secondary';
    }
  }

  private getTestStatusClass(status: string): string {
    switch (status) {
      case 'passed':
        return 'badge-passed';
      case 'failed':
        return 'badge-failed';
      case 'expired':
        return 'badge-expired';
      case 'in_progress':
        return 'badge-in-progress';
      case 'not_started':
        return 'badge-not-started';
      default:
        return 'bg-secondary';
    }
  }
}
